import { useState } from "react";
import cus1_mobi from "../../assets/images/Customer/cus1_mobi.webp";
import cus1_pc from "../../assets/images/Customer/cus1_pc.webp";
import custombanner_mobi from "../../assets/images/Customer/custombanner_mobi.webp";
import custombanner_pc from "../../assets/images/Customer/custombanner_pc.webp";
import hand from "../../assets/images/Customer/hand.svg";
import conet from "../../assets/images/Customer/conet.svg";
import ar_white from "../../assets/images/Introduction/ar_white.svg";
import home_white from "../../assets/images/Introduction/home_white.svg";
import { Button } from "flowbite-react";
import { Link } from "react-router-dom";
export default function CustomBanner() {
  const [isOpen, setIsOpen] = useState(false);

  const smoothScroll = (id) => {
    if (id === "top") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      const element = document.getElementById(id);

      if (element) {
        const headerElement = document.querySelector(".z-50.fixed");
        const headerHeight = headerElement?.offsetHeight || 0;

        const elementPosition = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    }
    setIsOpen(false);
  };
  return (
    <div
      className="w-full bg-center bg-cover bg-no-repeat"
      style={{
        backgroundImage: `url(${
          window.innerWidth < 768 ? custombanner_mobi : custombanner_pc
        })`,
      }}
    >
      <div className="w-full container mx-auto px-[20px] py-[20px] grid grid-cols-1 gap-4 md:grid-cols-1 lg:grid-cols-2 items-center md:gap-14">
        <div className="flex flex-col gap-3 w-full">
          <div className="w-full flex items-center gap-1 text-white">
            <img src={home_white} alt="ho1" />
            <img src={ar_white} alt="ar" />
            <p>Khách hàng & đối tác</p>
          </div>
          <div>
            <p className="text-white text-[28px] font-semibold md:text-[32px]">
              Đối tác chiến lược và khách hàng của Blue Rise
            </p>
          </div>
          <div>
            <p className="text-white">
              Cùng các đối tác và khách hàng của chúng tôi, Blue Rise cam kết
              mang đến giải pháp quản trị giáo dục hiệu quả và tối ưu.
            </p>
          </div>
          <div className="w-full flex flex-col gap-2 md:flex-row items-center">
            <Link to="/sto-detail" className="w-full">
              <Button className="w-full flex items-center justify-center md:w-full rounded-[30px] h-[54px] bg-white">
                <p className="text-black">Khám phá câu chuyện thành công</p>
              </Button>
            </Link>
            <Button
              className="w-full flex items-center justify-center md:w-3/12 rounded-[30px] h-[54px] bg-[#FDB62F]"
              onClick={() => {
                smoothScroll("advise");
                setIsOpen(false);
              }}
            >
              <p className="text-white">Liên hệ tư vấn</p>
            </Button>
          </div>
        </div>
        <div>
          <div className="block md:hidden relative">
            <div>
              <img
                src={cus1_mobi}
                alt="cu1"
                className="w-full h-auto object-cover"
              />
              <div className="absolute h-14 w-14 rounded-[16px] flex items-center justify-center z-10 border border-white bg-white top-10 right-14 animate-bounce  ">
                <img src={hand} alt="ha1" />
              </div>
              <div className="absolute h-14 w-14 rounded-[16px] flex items-center justify-center z-10 border border-[#FDB62F] bg-[#FDB62F] top-44 animate-bounce  ">
                <img src={conet} alt="co1" />
              </div>
            </div>
          </div>
          <div className="hidden md:block relative">
            <div>
              <img
                src={cus1_pc}
                alt="cu"
                className="w-full h-auto object-cover"
              />
              <div className="absolute h-16 w-16 rounded-[16px] flex items-center justify-center z-10 border border-white bg-white top-24 right-40 animate-bounce   ">
                <img src={hand} alt="hn" />
              </div>
              <div className="absolute h-16 w-16 rounded-[16px] flex items-center justify-center z-10 border border-[#FDB62F] bg-[#FDB62F] bottom-40 animate-bounce   ">
                <img src={conet} alt="ce" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
